import React, { useState } from "react";
import {
  GameMode,
  TeamInfoResponse,
} from "../../api/copenhunt/v1/copenhunt_pb";
import CustomModal from "../CustomModal";
import { useGame } from "../../api/copenhunt/v1/copenhunt_rbt_react";
import "../CustomModal.css";

export interface EditGameFormData {
  mode: GameMode;
  pingIntervalSeconds: number;
  numExtraPingsForHunters: number;
}

interface EditGameModalProps {
  gameId: string;
  mode: GameMode;
  pingIntervalSeconds: number;
  teamInfoById: { [key: string]: TeamInfoResponse };
}

const EditGameModal: React.FC<EditGameModalProps> = ({
  gameId,
  mode,
  pingIntervalSeconds,
  teamInfoById,
}) => {
  const [modalIsOpen, setModalIsOpen] = useState<boolean>(false);
  const { mutators } = useGame({ id: gameId });

  const [formData, setFormData] = useState<EditGameFormData>({
    mode: GameMode.NORMAL,
    pingIntervalSeconds: 0,
    numExtraPingsForHunters: 0,
  });

  const openModal = () => {
    const hunterTeam = Object.values(teamInfoById).find((t) => t.isHunter);
    setFormData({
      mode: mode,
      pingIntervalSeconds: pingIntervalSeconds,
      numExtraPingsForHunters: hunterTeam?.extraPingsRemaining ?? 0,
    });
    setModalIsOpen(true);
  };
  const closeModal = () => setModalIsOpen(false);

  const handleInputChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name, value } = event.target;
    setFormData({
      ...formData,
      [name]: !isNaN(Number(value)) ? Number(value) : value,
    });
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    await mutators.updateSettings(formData);
    closeModal();
  };

  return (
    <div>
      <button onClick={openModal}>Edit Game</button>
      <CustomModal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        onSubmit={handleSubmit}
        title="Edit Game Settings"
      >
        <div className="modal-form-group">
          <label>Game Mode</label>
          <select
            name="mode"
            value={formData.mode}
            onChange={handleInputChange}
            className="modal-select"
          >
            <option value={GameMode.NORMAL}>Normal</option>
            <option value={GameMode.DISTANCES_ONLY}>Distances only</option>
          </select>
        </div>
        <div className="modal-form-group">
          <label>Ping Interval (seconds)</label>
          <input
            type="number"
            name="pingIntervalSeconds"
            value={formData.pingIntervalSeconds}
            onChange={handleInputChange}
            className="modal-input"
          />
        </div>
        <div className="modal-form-group">
          <label>Extra pings for hunters</label>
          <input
            type="number"
            name="numExtraPingsForHunters"
            value={formData.numExtraPingsForHunters}
            onChange={handleInputChange}
            className="modal-input"
          />
        </div>
      </CustomModal>
    </div>
  );
};

export default EditGameModal; 